import {Icon} from './Icon';
import {useLocation} from 'react-router';
import {historicReturnPath} from '../historic-attribution-review';
import {useStaffSession} from './StaffSession';
import {Link} from './ScopedLink';
export function HistoricReturnLink(){
 const location=useLocation(),session=useStaffSession(),building=session?.effectiveScope.kind==='building'?session.effectiveScope.id:undefined;
 const path=historicReturnPath(location.state?.historicReturnTo,building);
 return path?<Link className="back-link" to={path}><Icon name="arrow-left"/> Historic review</Link>:null;
}
